fun getFlavor(): Flavor = flavor